import type { FC } from 'react';
import { Route } from 'react-router-dom';
import { useNotificationServicePublic } from 'src/apis/notification-service/use-notification-service-root';
import { ThrowNotFound } from 'src/components/feedback/not-found';
import { RootRoutes } from 'src/components/root-routes';
import { PageSpinner } from 'src/components/spinner-container';
import { NotificationDetails } from 'src/pages/notifications/details';
import { NotificationsOverview } from 'src/pages/notifications/overview';

export const Notifications: FC = () => {
  const notificationService = useNotificationServicePublic();
  if (!notificationService.response) {
    return <PageSpinner />;
  }

  return (
    <RootRoutes>
      <Route
        path="/notifications"
        element={
          <NotificationsOverview notificationService={notificationService} />
        }
      />
      <Route
        path="/notifications/:notificationId"
        element={
          <NotificationDetails notificationService={notificationService} />
        }
      />

      <Route path="*" element={<ThrowNotFound />} />
    </RootRoutes>
  );
};
